import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const HeroFavoriteAndSearchCard = createComponent('div', {
  className:
    'h-fit rounded-md border border-solid border-grey-2 bg-white l:h-[448px]'
});

export const FinanceTradeWrapper = createComponent<
  ElementWithProps<{ showPurchase: boolean }>
>('div', props => ({
  className: cx(
    'grid grid-cols-1 gap-24 m:grid-cols-2 min-[1200px]:grid-cols-1',
    props.showPurchase
      ? 'w-full'
      : 'col-span-1 m:col-span-2 min-[1200px]:col-span-1'
  )
}));

export const GridWrapper = createComponent<
  ElementWithProps<{ showPurchase: boolean; negativeTopMargin: string }>
>('div', ({ showPurchase, negativeTopMargin }) => ({
  className: cx(
    'z-1 grid grid-cols-1 min-[1200px]:grid-cols-3',
    negativeTopMargin,
    showPurchase
      ? 'gap-y-24 l:grid-rows-[448px_216px] min-[1200px]:grid-rows-[448px] min-[1200px]:gap-x-24 '
      : 'gap-24 m:grid-cols-2'
  )
}));
